import api from './api';

function extractFilename(disposition, fallback) {
  const utf = String(disposition || '').match(/filename\*=UTF-8''([^;]+)/i);
  if (utf) {
    try { return decodeURIComponent(utf[1]); } catch (_) { /* use fallback */ }
  }
  return fallback;
}

export const documentsService = {
  getAll: (params = {}) => api.get('/documents', { params }).then(response => response.data),
  getPrefill: taskId => api.get(`/documents/prefill/${taskId}`).then(response => response.data),
  createWorkAct: data => api.post('/documents/work-acts', data).then(response => response.data),
  delete: id => api.delete(`/documents/${id}`),
  download: async (id, fallbackName = `Акт-${id}.docx`) => {
    const response = await api.get(`/documents/${id}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = extractFilename(response.headers?.['content-disposition'], fallbackName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};
